import { showToast } from "./toast.js";

const TIMEOUT_AFTER_SUBMIT = 5000; // 5 seconds
const ERROR_MESSAGE = "Oops! There was a problem submitting your message";

function handleSuccess(form) {
    showToast("Thanks for your submission!", "success");
            form.reset();
            const submitButton = document.getElementById("contact-submit-button");
            // Disable the button
            submitButton.disabled = true;
            setTimeout(() => {
                // Re-enable the button after 5 seconds
                submitButton.disabled = false;
            }, TIMEOUT_AFTER_SUBMIT);
}

export async function handleSubmit(event) {
    event.preventDefault();
    var formData = new FormData(event.target);
    var data = Object.fromEntries(formData.entries());

    const { name, email, message } = data;

    if (!name || !email || !message) {
        showToast("Please fill in all fields", "error");
        return;
    }

    fetch(event.target.action, {
        method: event.target.method,
        body: JSON.stringify(data),
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.ok) {
            handleSuccess(event.target);
        } else {
            response.json().then(data => {
                if (Object.hasOwn(data, 'errors')) {
                    showToast(data["errors"].map(error => error["message"]).join(", "), "error")
                } else {
                    showToast(ERROR_MESSAGE, "error");
                    console.error('There was a problem with your fetch operation:', data);
                }
            })
        }
    }).catch(error => {
        showToast(ERROR_MESSAGE, "error");
        console.error('There was a problem with your fetch operation:', error);
    });
}